/**
 * <RankingRowSkeleton> — la forme d'une ligne de classement pendant le chargement.
 *
 * Le rang, l'avatar, le nom et son titre, l'XP : la géométrie est celle de `<RankingRow>`,
 * importée et non recopiée.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardListRow } from "../CardList"
import { RANK_COLUMN_WIDTH, RANKING_AVATAR_SIZE } from "./RankingRow"

export function RankingRowSkeleton() {
    return (
        <CardListRow>
            <Row gap="3">
                <View style={styles.rank}>
                    <Skeleton textSize="text-md" width={16} />
                </View>
                <Skeleton shape="circle" size={RANKING_AVATAR_SIZE} />
                <Stack gap="0" style={styles.body}>
                    <Skeleton textSize="text-md" width={110} />
                    <Skeleton textSize="text-sm" width={80} />
                </Stack>
                <Skeleton textSize="text-md" width={64} />
            </Row>
        </CardListRow>
    )
}

const styles = StyleSheet.create(() => ({
    rank: { width: RANK_COLUMN_WIDTH, alignItems: "center" },
    body: { flex: 1, flexShrink: 1 },
}))
